import register from '@/components/features/cms/blocks/TeaserCard/register';
import { TeaserCard } from './TeaserCard';

register(TeaserCard);
